import React, { useState } from 'react';
import { initializeApp } from 'firebase/app'; // Импортируем только нужную функцию
import { getMessaging, onMessage, getToken } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: "AIzaSyAVQJrcpz3UDkBJrJk-m86K-UtDgAYxGD0",
  authDomain: "sevitagro-1b38a.firebaseapp.com",
  projectId: "sevitagro-1b38a",
  storageBucket: "sevitagro-1b38a.firebasestorage.app",
  messagingSenderId: "19314076651",
  appId: "1:19314076651:web:13537082215757f52007ae"
};
let initMessaging = ()=>{
  
const app = initializeApp(firebaseConfig);

// Получаем экземпляр мессенджера
const messaging = getMessaging(app);

// Обработчик входящих сообщений
onMessage(messaging, (payload) => {
    console.log('Received message:', payload);
});

// Запрашиваем токен устройства
getToken(messaging, {vapidKey: 'BIIcklEhMl6QyjN6uR3CFr83bma6KsHcVIo03Xa1XWOIDCXh3ysFVXA8sAnxVfeHKIG5dUo0qGsKlZAPTi7TTL0'})
    .then((currentToken) => {
        if (currentToken) {
            localStorage.setItem('notificationToken', currentToken);
            sendTokenToServer(currentToken)
            console.log('Current Token:', currentToken);
        } else {
            console.log('No registration token available.');
        }
    })
    .catch((err) => {
        console.log('An error occurred while retrieving token.', err);
    });

let sendTokenToServer = (token) => {
    // Передача токена на сервер для дальнейшего использования
    fetch('/firebase/save-token', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ token }),
    }).then(response => response.json())
      .then(data => console.log(data))
      .catch(error => console.error('Error:', error));
  };
}
// Инициализируем Firebase



// const Notifications = () => {
// return (
//     <div>
       
//           <button onClick={initMessaging}>Подписаться на уведомления</button>
//       </div>
// )
// }

export default initMessaging;